import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Renderer2,
  ChangeDetectorRef,
} from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MatDialog } from '@angular/material/dialog';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { LoggingService } from 'src/app/services/consoleLogs';
import { BaseServicesService } from 'src/app/services/base-services/base-services.service';
import { NavigationEnd, Router } from '@angular/router';
import { DoctorProfile } from 'src/app/models/profile.model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { filter } from 'rxjs';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { TenantUIResponse } from 'src/app/models/tenant.model';
import { ToastConfig } from 'src/app/pages/ui-components/shared/components/toast/toast.component';
import { ToastService } from 'src/app/services/toast.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  animations: [
    trigger('imagePopup', [
      state('void', style({ opacity: 0, transform: 'scale(0.8)' })),
      transition('void => *', [animate('0.3s ease-in-out')]),
      transition('* => void', [
        animate(
          '0.3s ease-in-out',
          style({ opacity: 0, transform: 'scale(0.8)' })
        ),
      ]),
    ]),
    trigger('overlayAnimation', [
      state('void', style({ opacity: 0 })),
      transition(':enter, :leave', [
        animate('200ms ease-in-out')
      ])
    ]),
    trigger('dialogAnimation', [
      state('void', style({ transform: 'scale(0.9)', opacity: 0 })),
      transition(':enter', [
        animate('200ms ease-out', style({ transform: 'scale(1)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ transform: 'scale(0.9)', opacity: 0 }))
      ])
    ])
  ],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, AfterViewInit {
  logoPath: string | null = null;
  showProfileDialog: boolean = false;
  editableName: string = '';
  showChangePassword: boolean = false;
  currentPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  isProcessing: boolean = false;
  profileForm: any;
  email: string | null = null;
  profileError: string = '';
  passwordError: string = '';
  passwordSuccess: string = '';
  isMobileView: boolean = false;
  @Input() isCollapsed: boolean = false;

  // Custom Toast Properties
  toast = {
    show: false
  };

  toastConfig: ToastConfig = {
    type: 'success',
    title: '',
    message: '',
    duration: 3000,
    showIcon: true,
    position: 'bottom-center'
  };

  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  profileData: DoctorProfile | undefined;

  passwordErrors = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  avatarList: string[] = [
    '../../../../assets/images/profile/user-1.jpg',
    '../../../../assets/images/profile/user-2.jpg',
    '../../../../assets/images/profile/user-3.jpg',
    '../../../../assets/images/profile/user-4.jpg',
  ];
  selectedAvatar!: string;
  imageUrl = this.avatarList[0];
  showAvatarList = false;
  isEditingAvatar = false;
  showFiller = false;
  visible: boolean = false;
  isDropdownVisible: boolean = false;
  enlargedImageVisible = false;
  activeIndex: number = 1;
  isUploading = false;
  profileName: string = '';
  selectedImageUrl: string | ArrayBuffer | null = null;
  selectedImageVisible: boolean = false;
  profilePicUrl: string = '';
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('blurDialog') blurDialog!: ElementRef;
  isModulePage: boolean = false;
  defaultImageUrl = '../../../../assets/images/logos/NoProfile.jpg';
  uploadName: boolean = false;
  logoWidth = '100';
  logoHeight = '50';
  logoAlt = 'Logo';
  loginPath: string = '';
  loading: boolean = true;
  tenantUI!: TenantUIResponse;
  userDetails: any;
  isMobileNavOpen: boolean = false;
  userEmail: any;
  passwordForm!: FormGroup;
  private alertTimeout: any;

  // Header UI
  searchQuery: string = '';
  breadcrumbs: { label: string; url?: string }[] = [];
  navItems: any[] = [];


  constructor(
    public dialog: MatDialog,
    private router: Router,
    private baseServicesService: BaseServicesService,
    private fb: FormBuilder,
    private renderer: Renderer2,
    private loggingService: LoggingService,
    private location: Location, private toastService: ToastService,
    private cd: ChangeDetectorRef
  ) {
    this.initializePasswordForm();

    this.baseServicesService.profilePicUrl$.subscribe((url) => {
      this.profilePicUrl = url;
    });
    this.baseServicesService.profileName$.subscribe((name) => {
      this.profileName = name;
    });
    this.profileForm = this.fb.group({
      name: [this.profileName, Validators.required],
    });
    this.baseServicesService.breadcrumbUpdate$.subscribe(update => {
      if (update) {
       
        this.nameCache.set(update.id, update.name);

        // Rebuild breadcrumbs with the current URL
        this.buildBreadcrumbs(this.router.url);

        // Force change detection to update the view
        this.cd.detectChanges();

      }
    });



  }


  private showToast(type: 'success' | 'error' | 'warning' | 'info', title: string, message: string): void {
    this.toastService.showToast(type, title, message);
  }

  ngAfterViewInit(): void {
    if (this.uploadName) {
      const dialogMask = this.blurDialog.nativeElement.closest('.p-dialog-mask');
      if (dialogMask) {
        this.renderer.setStyle(dialogMask, 'backdrop-filter', 'blur(8px)');
        this.renderer.setStyle(dialogMask, 'background-color', 'rgba(255, 255, 255, 0.6)');
      }
    }
  }

  onImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.defaultImageUrl;
  }

  ngOnInit(): void {
    this.loadTenantBranding();
    this.loadTenantUI();
    this.loadUserDetails();
    this.subscribeToNavItems();
  }

  private subscribeToNavItems(): void {
    this.baseServicesService.getFeatureOptions().subscribe({
      next: (res) => {
        if (res.data && res.data.features) {
          this.navItems = res.data.features;
          this.loggingService.log('Navigation items loaded in header:', this.navItems);
          // Rebuild breadcrumbs with new nav data
          this.buildBreadcrumbs(this.router.url);
        }
      },
      error: (err) => {
        this.loggingService.error('Error loading nav items in header:', err);
      }
    });
  }

  private initializePasswordForm(): void {
    this.passwordForm = this.fb.group({
      currentPassword: ['', [Validators.required, Validators.minLength(6)]],
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]]
    }, {
      validators: this.passwordMatchValidator
    });
  }

  private passwordMatchValidator(form: FormGroup): { [key: string]: boolean } | null {
    const newPassword = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;

    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      return { 'passwordMismatch': true };
    }
    return null;
  }

  onChangePassword(): void {
    if (this.passwordForm.invalid) {
      this.markFormGroupTouched(this.passwordForm);
      return;
    }

    this.clearPasswordError();
    this.clearPasswordSuccess();
    this.isProcessing = true;

    const formValue = this.passwordForm.value;

    this.baseServicesService.changePassword(
      formValue.currentPassword,
      formValue.newPassword,
      formValue.confirmPassword
    ).subscribe({
      next: (response) => {
        this.isProcessing = false;
        this.passwordSuccess = response.message || 'Password changed successfully!';
        this.showToast('success', 'Success', response.message || 'Password changed successfully!');

        setTimeout(() => {
          this.clearPasswordSuccess();
          this.disablePasswordChange();
        }, 3000);
      },
      error: (error) => {
        this.isProcessing = false;
        this.loggingService.error('Password change error:', error);
        this.passwordError = error.error?.message || 'Failed to change password. Please try again.';
        this.showToast('error', 'Error', error.error?.message || 'Failed to change password. Please try again.');
      }
    });
  }

  clearProfileError(): void {
    this.profileError = '';
  }

  clearPasswordError(): void {
    this.passwordError = '';
  }

  clearPasswordSuccess(): void {
    this.passwordSuccess = '';
  }

  disablePasswordChange(): void {
    this.showChangePassword = false;
    this.passwordForm.reset();
    this.clearPasswordError();
    this.clearPasswordSuccess();
    this.isProcessing = false;
  }

  closeProfileDialog(): void {
    this.showProfileDialog = false;
    this.showChangePassword = false;
    this.isProcessing = false;
    this.passwordForm.reset();
    this.clearProfileError();
    this.clearPasswordError();
    this.clearPasswordSuccess();
  }

  enablePasswordChange(): void {
    this.showChangePassword = true;
    this.passwordForm.reset();
    this.clearPasswordError();
    this.clearPasswordSuccess();
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormControl) {
        control.markAsTouched();
      } else if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  get currentPasswordControl(): FormControl {
    return this.passwordForm.get('currentPassword') as FormControl;
  }

  get newPasswordControl(): FormControl {
    return this.passwordForm.get('newPassword') as FormControl;
  }

  get confirmPasswordControl(): FormControl {
    return this.passwordForm.get('confirmPassword') as FormControl;
  }

  loadUserDetails() {
    this.baseServicesService.getUserDetailsById().subscribe({
      next: (res) => {
        this.loggingService.log("User Details:", res);
        this.userDetails = res?.data;

        // Update user state service
        if (this.userDetails?.name) {
          this.baseServicesService.updateUserName(this.userDetails.name);
        }
        if (this.userDetails?.profilePic) {
          this.baseServicesService.updateUserAvatar(this.userDetails.profilePic);
        }
      },
      error: (err) => {
        this.loggingService.error("Error fetching user details:", err);
      }
    });
  }



  openProfileDialog() {
    this.editableName = this.userDetails?.name || '';
    this.userEmail = this.userDetails?.email || '';
    this.showChangePassword = false;
    this.resetPasswordFields();
    this.showProfileDialog = true;

    setTimeout(() => {
      this.cd.detectChanges();
    });
  }

  cancelProfileEdit() {
    this.showProfileDialog = false;
    this.showChangePassword = false;
    this.resetPasswordFields();
  }

  saveProfileChanges(): void {
    if (this.isProcessing || !this.isFormValid()) return;

    this.isProcessing = true;

    this.baseServicesService.updateProfile(this.editableName).subscribe({
      next: (response) => {
        this.isProcessing = false;
        this.userDetails.name = this.editableName;

        // Update user state service with new name
        this.baseServicesService.updateUserName(this.editableName);

        this.showToast('success', 'Success', 'Profile updated successfully!');
        this.closeProfileDialog();
      },
      error: (error) => {
        this.isProcessing = false;
        this.showToast('error', 'Error', error.error?.message || 'Failed to update profile');
      }
    });
  }



  updateProfile() {
    const updateData = {
      name: this.editableName
    };
  }

  updatePassword() {
    const passwordData = {
      currentPassword: this.currentPassword,
      newPassword: this.newPassword
    };
  }

  isFormValid(): boolean {
    if (this.showChangePassword) {
      if (!this.currentPassword || !this.newPassword || !this.confirmPassword) {
        return false;
      }
      if (this.newPassword !== this.confirmPassword) {
        return false;
      }
      if (this.newPassword.length < 8) {
        return false;
      }
      if (this.currentPassword === this.newPassword) {
        return false;
      }
    } else {
      if (!this.editableName.trim()) {
        return false;
      }
    }
    return true;
  }

  resetPasswordFields() {
    this.currentPassword = '';
    this.newPassword = '';
    this.confirmPassword = '';
  }

  triggerImageUpload() {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  onImageSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.uploadProfileImage(file);
    }
  }

  uploadProfileImage(file: File) {
    this.loggingService.log("Uploading image:", file);
  }

  private loadTenantUI(): void {
    this.loading = true;
    this.baseServicesService.getTenantUI().subscribe({
      next: (data: TenantUIResponse) => {
        this.tenantUI = data;
        this.loggingService.log("Fresh tenantUI from API", this.tenantUI);
        localStorage.setItem('tenantUI', JSON.stringify(data));
        this.applyTenantUI(data);
        this.loading = false;
      },
      error: (err) => {
        this.loggingService.error('Error fetching tenant UI from API:', err);
        const cachedData = localStorage.getItem('tenantUI');
        if (cachedData) {
          this.loggingService.log("Falling back to cached tenantUI", cachedData);
          this.applyTenantUI(JSON.parse(cachedData));
        }
        this.loading = false;
      }
    });
  }

  private applyTenantUI(data: TenantUIResponse): void {
    const branding = data.data.portalConfig.branding;
    document.documentElement.style.setProperty('--brand-color', branding.brandColor);
    document.documentElement.style.setProperty('--secondary-color', branding.secondaryColor);
    if (branding.logo?.url) {
      this.loginPath = branding.logo.url;
    }
  }

  private loadTenantBranding(): void {
    const cachedData = localStorage.getItem('tenantUI');
    if (!cachedData) return;

    try {
      const tenantUI = JSON.parse(cachedData);
      const branding = tenantUI?.data?.portalConfig?.branding;

      if (branding?.logo) {
        this.logoPath = branding.logo.url || '';
        this.logoWidth = branding.logo.width || '100';
        this.logoHeight = branding.logo.height || '50';
        this.logoAlt = branding.logo.alt || 'Logo';
        this.loggingService.log("this.logoHeight", this.logoHeight);
      }
    } catch (e) {
      this.loggingService.error('Error parsing tenantUI from localStorage', e);
    }

    this.checkModulePage(this.router.url);
    this.buildBreadcrumbs(this.router.url);
    const token = localStorage.getItem('authToken');

    if (token) {
      this.loggingService.log('Raw token:===>', token);
      const parts = token.split('.');
      if (parts.length === 3) {
        const payload = JSON.parse(atob(parts[1]));
        this.loggingService.log('Decoded payload:', payload);
        this.email = payload.email;
      } else {
        this.loggingService.error('Invalid token structure.');
      }
    } else {
      this.loggingService.log('No token found in session storage.');
    }

    this.loggingService.log('Email:', this.email);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navigationEvent = event as NavigationEnd;
        this.checkModulePage(navigationEvent.url);
        this.buildBreadcrumbs(navigationEvent.url);
        this.loggingService.log(`Navigation URL: ${navigationEvent.url}`);
        this.loggingService.log(`isModulePage: ${this.isModulePage}`);
      });
  }

  goBack(): void {
    this.location.back();
  }

  checkModulePage(url: string): void {
    this.isModulePage = url.includes('/lms/admin/news');
  }

  private formatBreadcrumbLabel(segment: string): string {
    const cleaned = (segment || '').trim();
    if (!cleaned) return '';

    const withSpaces = cleaned
      .replace(/[-_]/g, ' ')
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2');

    return withSpaces
      .split(' ')
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  }
  private nameCache: Map<string, string> = new Map();

  // Updated buildBreadcrumbs method - supports 4-level hierarchy
  private buildBreadcrumbs(url: string): void {

    // Parse URL to separate path and query parameters
    const [path, queryString] = (url || '').split('?');
    const currentPath = path.startsWith('/') ? path : '/' + path;

    // Parse query parameters to get ID
    const urlParams = new URLSearchParams(queryString || '');
    const webinarId = urlParams.get('id');

    // Try to find this route in nav items
    let matchedNavCap: string | null = null;
    let matchedDisplayName: string | null = null;
    let matchedListRoute: string | null = null;
    let isDirectMatch = false;
    let matchedRelatedRoute: string | null = null;

    for (const parent of this.navItems) {
      if (!parent.children?.length) continue;

      for (const child of parent.children) {
        const childRoute = child.route?.startsWith('/') ? child.route : '/' + (child.route || '');
        // Direct match - user is on the list page itself
        if (this.routesMatch(childRoute, currentPath)) {
          matchedNavCap = parent.navCap;
          matchedDisplayName = child.displayName;
          matchedListRoute = childRoute;
          isDirectMatch = true;
          break;
        }

        // Related route match - user is on a sub-page (add/update/etc)
        if (child.relatedRoutes?.length) {
          for (const r of child.relatedRoutes) {
            const normalized = r.startsWith('/') ? r : '/' + r;
            if (this.relatedRouteMatches(normalized, currentPath)) {
              matchedNavCap = parent.navCap;
              matchedDisplayName = child.displayName;
              matchedListRoute = childRoute;
              matchedRelatedRoute = normalized;
              isDirectMatch = false;
              break;
            }
          }
        }

        if (matchedNavCap && matchedDisplayName) break;
      }

      if (matchedNavCap && matchedDisplayName) break;
    }

    // CASE 1: Direct match - user is on the list page itself
    if (isDirectMatch && matchedNavCap && matchedDisplayName) {
      this.breadcrumbs = [
        { label: matchedNavCap },
        { label: matchedDisplayName }
      ];
      return;
    }

    // CASE 2: Related route match - user is on sub-page (add/update/etc)
    if (matchedNavCap && matchedDisplayName && matchedListRoute && matchedRelatedRoute) {
      const breadcrumbs: { label: string; url?: string }[] = [];

      // 1. Parent (navCap) - e.g., "Webinar"
      breadcrumbs.push({ label: matchedNavCap });

      // 2. Sibling list page (displayName as link) - e.g., "Webinars"
      breadcrumbs.push({ label: matchedDisplayName, url: matchedListRoute });

      // 3. Action label derived from related route - e.g., "Past Webinar Analytics"
      const actionLabel = this.deriveActionLabel(matchedRelatedRoute);
      if (actionLabel) {
        breadcrumbs.push({ label: actionLabel });
      }

      // 4. Entity name from URL params (ID from query string or path)
      let entityName: string | null = null;

      // First try to get from query parameter
      if (webinarId) {

        // Try to get from service cache
        entityName = this.baseServicesService.getBreadcrumbName(webinarId);

        // If not found, try local cache
        if (!entityName && this.nameCache.has(webinarId)) {
          entityName = this.nameCache.get(webinarId) || null;
        }
      }

      // If no entity name found from query param, try from path
      if (!entityName) {
        entityName = this.extractEntityNameFromUrl(currentPath, matchedRelatedRoute);
        //console.log(`🏗️ [Breadcrumbs] From path extraction: ${entityName}`);
      }

      if (entityName) {
        breadcrumbs.push({ label: entityName });
      }

      // Last item should not be a link
      this.breadcrumbs = breadcrumbs.map((c, idx, arr) => ({
        ...c,
        url: idx === arr.length - 1 ? undefined : c.url,
      }));

      return;
    }


    let segments = path.split('/').filter(Boolean);

    // Remove 'lms' prefix
    if (segments.length > 0 && segments[0].toLowerCase() === 'lms') {
      segments = segments.slice(1);
    }

    const fallbackCrumbs: { label: string; url?: string }[] = [];
    let skipNext = false;

    for (let i = 0; i < segments.length; i++) {
      if (skipNext) {
        skipNext = false;
        continue;
      }

      const seg = segments[i];

      if (this.isObjectId(seg)) {
        if (i + 1 < segments.length && this.isSlug(segments[i + 1])) {
          const name = this.slugToReadableName(segments[i + 1]);
          const cumulative = '/lms/' + segments.slice(0, i + 2).join('/');
          fallbackCrumbs.push({ label: name, url: cumulative });
          this.nameCache.set(seg, name);
          skipNext = true;
          continue;
        }

        if (this.nameCache.has(seg)) {
          const cumulative = '/lms/' + segments.slice(0, i + 1).join('/');
          fallbackCrumbs.push({ label: this.nameCache.get(seg)!, url: cumulative });
          continue;
        }
      }

      if (this.isSlug(seg) && i > 0 && this.isObjectId(segments[i - 1])) {
        continue;
      }

      const label = this.formatBreadcrumbLabel(seg);
      const cumulative = '/lms/' + segments.slice(0, i + 1).join('/');
      fallbackCrumbs.push({ label, url: cumulative });
    }

    // If we have a webinar ID from query param and a title in cache, add it as the last breadcrumb
    if (webinarId) {
      const webinarTitle = this.baseServicesService.getBreadcrumbName(webinarId) || this.nameCache.get(webinarId);
      if (webinarTitle) {
        fallbackCrumbs.push({ label: webinarTitle });
        console.log(`🏗️ [Breadcrumbs] Added webinar title to fallback: ${webinarTitle}`);
      }
    }

    this.breadcrumbs = fallbackCrumbs
      .map(c => c.label === 'Admin' ? { ...c, label: 'User Management' } : c)
      .map((c, idx, arr) => ({
        ...c,
        url: idx === arr.length - 1 ? undefined : c.url,
      }));

    console.log('🏗️ [Breadcrumbs] Fallback breadcrumbs:', this.breadcrumbs);
  }
  /**
   * Match a related route pattern (which may contain :id placeholders)
   * against the current route.
   * Example: pattern "/lms/admin/updateUser/:id" matches "/lms/admin/updateUser/123abc"
   */
  private relatedRouteMatches(pattern: string, currentRoute: string): boolean {
    if (!pattern || !currentRoute) return false;

    // Convert pattern to regex by replacing :param with regex group
    const patternSegments = pattern.replace(/\/+$/, '').toLowerCase().split('/');
    const routeSegments = currentRoute.replace(/\/+$/, '').toLowerCase().split('/');

    // Pattern with :id can match route with extra segments (id + slug)
    // Allow current route to have equal or one more segment than pattern
    if (routeSegments.length < patternSegments.length) return false;
    if (routeSegments.length > patternSegments.length + 1) return false;

    for (let i = 0; i < patternSegments.length; i++) {
      const patternSeg = patternSegments[i];
      const routeSeg = routeSegments[i];

      // Skip param placeholders like :id
      if (patternSeg.startsWith(':')) continue;

      // Otherwise must match exactly
      if (patternSeg !== routeSeg) return false;
    }

    return true;
  }

  /**
   * Derive an action label from a related route pattern.
   * Examples:
   *   "/lms/admin/updateUser/:id"  → "Update User"
   *   "/lms/admin/addUser"          → "Add User"
   *   "/lms/admin/updateRole/:id"   → "Update Role"
   */
  private deriveActionLabel(relatedRoute: string): string {
    // Remove leading slash and split
    const segments = relatedRoute.split('/').filter(Boolean);
    console.log('🏷️ [DeriveAction] Route segments:', segments);

    // Find the action segment (skip 'lms', 'admin', and :params)
    for (let i = segments.length - 1; i >= 0; i--) {
      const seg = segments[i];
      if (seg.startsWith(':')) continue; // skip param
      if (['lms', 'admin'].includes(seg.toLowerCase())) continue;

      // Special handling for specific routes
      if (seg === 'past-webinar-analitics') {
        return 'Past Webinar Analytics';
      }
      if (seg === 'webinar-analitics') {
        return 'Webinar Analytics';
      }
      if (seg === 'add-webinar') {
        return 'Add Webinar';
      }
      if (seg === 'update-webinar') {
        return 'Update Webinar';
      }

      // This is our action segment
      return this.formatBreadcrumbLabel(seg);
    }

    return '';
  }
  /**
   * Extract entity name from current URL based on related route pattern.
   * Looks at URL segments after the pattern's :id position.
   * If next segment is a slug (like "chelladurai" or "john-doe"), use it as the name.
   * Otherwise, check the cache for the ID.
   */
  private extractEntityNameFromUrl(currentRoute: string, relatedRoute: string): string {
    const patternSegments = relatedRoute.split('/').filter(Boolean);
    const routeSegments = currentRoute.split('/').filter(Boolean);

    const idIndex = patternSegments.findIndex(s => s.startsWith(':'));

    if (idIndex === -1) {
      return '';
    }

    const idValue = routeSegments[idIndex];
    if (!idValue) return '';

    // ✅ Check breadcrumb service cache first (this was already there)
    const cachedName = this.baseServicesService.getBreadcrumbName(idValue);
    console.log(`Checking breadcrumb service cache for ID ${idValue}:`, cachedName);
    if (cachedName) {
      return cachedName;
    }

    // Check slug from URL
    const slugValue = routeSegments[idIndex + 1];
    if (slugValue && this.isSlug(slugValue)) {
      const name = this.slugToReadableName(slugValue);
      this.nameCache.set(idValue, name);
      return name;
    }

    // Check local name cache
    if (this.nameCache.has(idValue)) {
      return this.nameCache.get(idValue)!;
    }

    if (this.isObjectId(idValue)) {
      return '';
    }

    return this.formatBreadcrumbLabel(idValue);
  }
  /**
   * Public method that child components can call to set the entity name
   * once it's loaded from the API.
   * 
   * Example usage in update-user.component.ts:
   *   ngOnInit() {
   *     this.userService.getUser(id).subscribe(user => {
   *       this.headerService.setBreadcrumbName(id, user.name);
   *     });
   *   }
   */
  public setBreadcrumbName(id: string, name: string): void {
    this.nameCache.set(id, name);
    // Rebuild breadcrumbs to reflect the new name
    this.buildBreadcrumbs(this.router.url);
  }

  // Helper method to check if string is a MongoDB ObjectId
  private isObjectId(str: string): boolean {
    return /^[0-9a-fA-F]{24}$/.test(str);
  }

  // Helper method to check if string is a URL slug
  private isSlug(str: string): boolean {
    return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(str) && !/^[0-9a-fA-F]{24}$/.test(str);
  }

  // Convert slug back to readable name
  private slugToReadableName(slug: string): string {
    return slug
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  private routesMatch(routeA: string, routeB: string): boolean {
    if (!routeA || !routeB) return false;
    const a = routeA.replace(/\/+$/, '').toLowerCase();
    const b = routeB.replace(/\/+$/, '').toLowerCase();
    return a === b;
  }

  logout(): void {
    this.router.navigate(['/']);
    localStorage.removeItem('authToken');
  }

  private fetchProfile(): void {
    this.baseServicesService.getProfile().subscribe(
      (data: DoctorProfile) => {
        this.profileData = data;
        this.profilePicUrl = data.data.profilePic || this.profilePicUrl;
        this.profileName = data.data.name || this.profileName;
      },
      (error) => {
        this.loggingService.error('Error fetching profile data:', error);
      }
    );
  }

  redirectToChangePassword() {
    this.router.navigate(['/ChangePassword'], {
      queryParams: { origin: 'header' },
    });
  }

  triggerFileInput() {
    if (this.fileInput) {
      this.loggingService.log('triggerFileInput called');
      this.fileInput.nativeElement.click();
    } else {
      this.loggingService.log('fileInput not found');
    }
  }

  updateNameDialog() {
    this.uploadName = true;
  }

  updateName() {
    this.uploadName = true;
    const updatedName = this.profileForm.get('name')?.value;
    this.loggingService.log('Updated Name:', updatedName);

    if (this.profileForm.valid) {
      const { name } = this.profileForm.value;

      this.baseServicesService.updateProfile(name).subscribe({
        next: (response) => {
          this.loggingService.log('Profile updated successfully:', response);
          this.uploadName = false;
          this.showToast('success', 'Success', 'Profile updated successfully!');
        },
        error: (error) => {
          this.loggingService.error('Error updating profile:', error);
          this.uploadName = false;
          this.showToast('error', 'Error', 'Failed to update profile.');
        },
      });
    }
  }

  onFileSelected(event: Event): void {
    this.loggingService.log('loggedd');
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.selectedImageUrl = e.target?.result || null;
        this.selectedImageVisible = true;
      };
      reader.readAsDataURL(input.files[0]);
    }
  }
  uploadSelectedImage(event: Event): void {
    event.stopPropagation();

    if (typeof this.selectedImageUrl === 'string') {
      this.isUploading = true;

      this.loadImageAsFile(this.selectedImageUrl)
        .then((file: File) => {
          this.baseServicesService.updateProfilePic(file).subscribe({
            next: (response) => {
              this.loggingService.log('Profile picture updated successfully', response);
              this.isUploading = false;

              // Update user state service with new avatar
              if (typeof this.selectedImageUrl === 'string') {
                this.profilePicUrl = this.selectedImageUrl;
                this.baseServicesService.updateUserAvatar(this.selectedImageUrl);
              }

              this.showToast('success', 'Upload Successful', 'Your profile picture has been updated successfully.');
              this.selectedImageVisible = false;
            },
            error: (error) => {
              this.loggingService.error('Error updating profile picture', error);
              this.isUploading = false;
              this.showToast('error', 'Upload Failed', 'There was an error updating your profile picture.');
            },
          });
        })
        .catch((err) => {
          this.loggingService.error('Error converting image URL to File object', err);
          this.isUploading = false;
          this.showToast('error', 'Upload Failed', 'There was an error processing the selected image.');
        });
    }
  }


  closeSelectedImage(): void {
    this.selectedImageVisible = false;
  }

  showDialog() {
    this.visible = true;
  }

  showEnlargedImage(): void {
    this.enlargedImageVisible = true;
    this.loggingService.log('click');
  }

  closeEnlargedImage(): void {
    this.enlargedImageVisible = false;
  }

  toggleDropdown() {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  addPhoto() {
    if (this.fileInput) {
      this.loggingService.log('triggerFileInput called');
      this.fileInput.nativeElement.click();
      this.isDropdownVisible = false;
    } else {
      this.loggingService.log('fileInput not found');
    }
  }

  handleFileInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.loggingService.log('Selected file:', file);
    }
  }

  saveSelectedAvatar() {
    this.loggingService.log('Avatar saved:', this.imageUrl);
    this.visible = false;
  }

  onDialogHide() {
    this.imageUrl = '../../../../assets/images/profile/user-1.jpg';
  }

  editAvatar() {
    this.showAvatarList = true;
    this.isDropdownVisible = false;
  }

  getLeftIndex() {
    return this.activeIndex === 0
      ? this.avatarList.length - 1
      : this.activeIndex - 1;
  }

  getRightIndex() {
    return (this.activeIndex + 1) % this.avatarList.length;
  }

  nextAvatar() {
    this.activeIndex = (this.activeIndex + 1) % this.avatarList.length;
  }

  previousAvatar() {
    this.activeIndex = this.activeIndex === 0
      ? this.avatarList.length - 1
      : this.activeIndex - 1;
  }

  previousImage(event: Event): void {
    event.stopPropagation();
    if (this.activeIndex > 0) {
      this.activeIndex--;
    }
  }

  nextImage(event: MouseEvent) {
    event.stopPropagation();
    if (this.activeIndex < this.avatarList.length - 1) {
      this.activeIndex++;
    }
  }

  getTransform(): string {
    return `translateX(-${this.activeIndex * 100}%)`;
  }

  confirmSelection() {
    this.loggingService.log('Selected Avatar:', this.selectedAvatar);
    this.showAvatarList = false;
  }

  closeOverlay(): void {
    this.enlargedImageVisible = false;
    this.showAvatarList = true;
    this.loggingService.log('closeOverlay');
  }

  closeAvatarList(): void {
    this.showAvatarList = false;
  }

  selectAvatar(avatar: string): void {
    this.loggingService.log('Clicked');
    this.imageUrl = avatar;
    this.showAvatarList = false;
    this.isUploading = true;
    this.loggingService.log('thisImage', this.imageUrl);

    this.loadImageAsFile(avatar).then((file: File) => {
      this.baseServicesService.updateProfilePic(file).subscribe({
        next: (response) => {
          this.loggingService.log('Profile picture updated successfully', response);
          this.isUploading = false;
          this.profilePicUrl = avatar;

          // Update user state service with new avatar
          this.baseServicesService.updateUserAvatar(avatar);

          this.showToast('success', 'Upload Successful', 'Your profile picture has been updated successfully.');
        },
        error: (error) => {
          this.loggingService.error('Error updating profile picture', error);
          this.isUploading = false;
          this.showToast('error', 'Upload Failed', 'There was an error updating your profile picture.');
        },
      });
    });
  }


  private loadImageAsFile(url: string): Promise<File> {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const file = new File([blob], 'profilePic.jpg', { type: blob.type });
          resolve(file);
        })
        .catch((err) => reject(err));
    });
  }

  toggleSidebar(): void {
    this.loggingService.log('Sidebar toggled');
  }

  toggleNav() {
    this.isMobileNavOpen = !this.isMobileNavOpen;
    this.toggleMobileNav.emit();
  }
}